let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("84U6s")).then(() => parcelRequire('2fak7'));